import QualificationCardGrid from './QualificationCardGrid';

function ExamTabs({ user }) {
  return (
    <QualificationCardGrid user={user} />
  );
}

export default ExamTabs;